<section class="credit-card-modal" aria-labelledby="card-dialog-title" aria-describedby="card-dialog-description">
  <header class="modal-header">
    <button mat-icon-button mat-dialog-close class="mobile-close" type="button" aria-label="Fechar modal de pagamento">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>

    <div class="header-copy">
      <h1 id="card-dialog-title">
        <span class="desktop-title">Pagar com cartão de crédito</span>
        <span class="mobile-title">Pagar com cartão</span>
      </h1>
      <p id="card-dialog-description">Preencha os dados para concluir o pagamento</p>
    </div>

    <div class="secure-header">
      <mat-icon aria-hidden="true">lock</mat-icon>
      <span class="desktop-title">Pagamento seguro</span>
      <span class="mobile-title">Seguro</span>
    </div>

    <button mat-icon-button mat-dialog-close class="desktop-close" type="button" aria-label="Fechar modal de pagamento">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <div class="modal-body">
    <form [formGroup]="form" class="payment-form" novalidate>
      <div *ngIf="fatura.CARTAO_CADASTRADO" class="registered-card-panel">
        <h2>Desejo pagar com</h2>
        <mat-radio-group formControlName="usarCartaoCadastrado" class="registered-card-options">
          <mat-radio-button color="primary" [value]="true">
            Cartão
            <img class="logo-card" [src]="getLogo(fatura.DADOS_BASICOS_CARTAO?.BANDEIRA ?? '')" [alt]="fatura.DADOS_BASICOS_CARTAO?.BANDEIRA">
            final {{ fatura.DADOS_BASICOS_CARTAO?.ULTIMOS_NUMEROS }}
          </mat-radio-button>
          <mat-radio-button color="primary" [value]="false">Cartão de crédito diferente</mat-radio-button>
        </mat-radio-group>
      </div>

      <section *ngIf="showCardFields" class="card-entry-grid">
        <div class="card-preview-column">
          <div class="card-preview" aria-label="Prévia visual do cartão">
            <div class="preview-topline">
              <mat-icon aria-hidden="true">contactless</mat-icon>
              <img *ngIf="cardBrandLogo" class="preview-brand-logo" [src]="cardBrandLogo" [alt]="cardBrandLabel">
            </div>
            <div class="card-chip" aria-hidden="true"></div>
            <div class="preview-number">{{ cardPreviewNumber }}</div>
            <div class="preview-bottomline">
              <span>{{ cardPreviewName }}</span>
              <div>
                <small>VÁLIDO ATÉ</small>
                <strong>{{ cardPreviewExpiry }}</strong>
              </div>
            </div>
          </div>

<!--          <div class="brand-status" aria-live="polite">-->
<!--            <mat-icon aria-hidden="true">verified_user</mat-icon>-->
<!--            <span *ngIf="cardBrand; else unknownBrand">Bandeira identificada automaticamente: <strong>{{ cardBrand }}</strong></span>-->
<!--            <ng-template #unknownBrand><span>Bandeira não identificada</span></ng-template>-->
<!--          </div>-->

          <div class="security-note desktop-security-note">
            <mat-icon aria-hidden="true">shield</mat-icon>
            <span>Seus dados são criptografados e usados apenas para processar o pagamento.</span>
          </div>
        </div>

        <div class="card-fields-column">
          <h2>Dados do cartão</h2>

          <div class="nationality-section">
            <mat-radio-group formControlName="nacionalidade" class="nationality-options" aria-label="Nacionalidade do titular">
              <mat-radio-button color="primary" value="brasileiro">Sou brasileiro</mat-radio-button>
              <mat-radio-button color="primary" value="estrangeiro">Sou estrangeiro</mat-radio-button>
            </mat-radio-group>
          </div>

          <mat-form-field appearance="fill" class="span-12 col-xs-12">
            <mat-label>Número do cartão</mat-label>
            <input cdkFocusInitial type="text" matInput formControlName="numeroCartao" mask="0000 0000 0000 0000" autocomplete="cc-number" inputmode="numeric" aria-describedby="numeroCartao-error">
            <img *ngIf="cardBrandLogo" matSuffix class="brand-logo" [src]="cardBrandLogo" [alt]="cardBrandLabel">
            <mat-error id="numeroCartao-error" *ngIf="fieldInvalid('numeroCartao')">{{ errorMessage('numeroCartao') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="span-4 expiry-field col-xs-12">
            <mat-label>Validade</mat-label>
            <input type="text" matInput formControlName="vencimento" mask="00/0000" autocomplete="cc-exp" inputmode="numeric" aria-describedby="vencimento-error">
            <mat-error id="vencimento-error" *ngIf="fieldInvalid('vencimento')">{{ errorMessage('vencimento') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="span-4 cvv-field col-xs-12">
            <mat-label>CVV</mat-label>
            <input type="password" matInput formControlName="cvv" autocomplete="cc-csc" inputmode="numeric" aria-describedby="cvv-error cvv-help">
            <mat-icon matSuffix id="cvv-help" aria-label="Código de segurança no verso do cartão">help_fill</mat-icon>
            <mat-error id="cvv-error" *ngIf="fieldInvalid('cvv')">{{ errorMessage('cvv') }}</mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="!estrangeiro" appearance="fill" class="span-4 tax-field col-xs-12">
            <mat-label>CPF/CNPJ</mat-label>
            <input type="text" matInput formControlName="documento" mask="000.000.000-00 || 00.000.000/0000-00" autocomplete="off" inputmode="numeric" aria-describedby="documento-error">
            <mat-error id="documento-error" *ngIf="fieldInvalid('documento')">{{ errorMessage('documento') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="span-12 col-xs-12">
            <mat-label>Nome impresso no cartão</mat-label>
            <input type="text" matInput formControlName="nomeCartao" autocomplete="cc-name" aria-describedby="nomeCartao-error">
            <mat-error id="nomeCartao-error" *ngIf="fieldInvalid('nomeCartao')">{{ errorMessage('nomeCartao') }}</mat-error>
          </mat-form-field>
        </div>
      </section>

<!--      <div *ngIf="showCardFields" class="security-note mobile-security-note">-->
<!--        <mat-icon aria-hidden="true">shield</mat-icon>-->
<!--        <span>Seus dados são criptografados e usados apenas para processar o pagamento.</span>-->
<!--      </div>-->

      <section *ngIf="showCardFields" class="address-section">
        <h2>Endereço de cobrança</h2>

        <div class="nationality-section">
          <mat-radio-group formControlName="localEndereco" class="nationality-options" aria-label="Localização do endereço de cobrança">
            <mat-radio-button color="primary" value="brasil">No Brasil</mat-radio-button>
            <mat-radio-button color="primary" value="exterior">No exterior</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="address-grid">
          <mat-form-field appearance="fill" class="postal-field col-3 col-xs-12">
            <mat-label>CEP</mat-label>
            <input *ngIf="!exterior" type="text" matInput formControlName="cep" (blur)="preencherCep()" mask="00000-000" autocomplete="postal-code" inputmode="numeric" aria-describedby="cep-error">
            <input *ngIf="exterior" type="text" matInput formControlName="cep" autocomplete="postal-code" aria-describedby="cep-error">
            <mat-progress-spinner *ngIf="isFetchingCep" matSuffix mode="indeterminate" diameter="20" aria-label="Buscando CEP"></mat-progress-spinner>
            <mat-error id="cep-error" *ngIf="fieldInvalid('cep')">{{ errorMessage('cep') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-5 col-xs-12">
            <mat-label>Endereço</mat-label>
            <input type="text" matInput formControlName="logradouro" autocomplete="address-line1" aria-describedby="logradouro-error">
            <mat-error id="logradouro-error" *ngIf="fieldInvalid('logradouro')">{{ errorMessage('logradouro') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-2 number-field col-xs-12">
            <mat-label>Número</mat-label>
            <input type="text" matInput formControlName="numero" autocomplete="address-line2" inputmode="numeric" aria-describedby="numero-error">
            <mat-error id="numero-error" *ngIf="fieldInvalid('numero')">{{ errorMessage('numero') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-2 complement-field col-xs-12">
            <mat-label>Complemento</mat-label>
            <input type="text" matInput formControlName="complemento" autocomplete="address-line3">
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-4 district-field col-xs-12">
            <mat-label>Bairro</mat-label>
            <input type="text" matInput formControlName="bairro" aria-describedby="bairro-error">
            <mat-error id="bairro-error" *ngIf="fieldInvalid('bairro')">{{ errorMessage('bairro') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-5 city-field col-xs-12">
            <mat-label>Cidade</mat-label>
            <input type="text" matInput formControlName="cidade" autocomplete="address-level2" aria-describedby="cidade-error">
            <mat-error id="cidade-error" *ngIf="fieldInvalid('cidade')">{{ errorMessage('cidade') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-3 state-field col-xs-12">
            <mat-label>Estado</mat-label>
            <mat-select *ngIf="!exterior" formControlName="estado" aria-describedby="estado-error">
              <mat-option value="">Selecione...</mat-option>
              <mat-option value="AC">Acre</mat-option>
              <mat-option value="AL">Alagoas</mat-option>
              <mat-option value="AP">Amapá</mat-option>
              <mat-option value="AM">Amazonas</mat-option>
              <mat-option value="BA">Bahia</mat-option>
              <mat-option value="CE">Ceará</mat-option>
              <mat-option value="DF">Distrito Federal</mat-option>
              <mat-option value="ES">Espírito Santo</mat-option>
              <mat-option value="GO">Goiás</mat-option>
              <mat-option value="MA">Maranhão</mat-option>
              <mat-option value="MT">Mato Grosso</mat-option>
              <mat-option value="MS">Mato Grosso do Sul</mat-option>
              <mat-option value="MG">Minas Gerais</mat-option>
              <mat-option value="PA">Pará</mat-option>
              <mat-option value="PB">Paraíba</mat-option>
              <mat-option value="PR">Paraná</mat-option>
              <mat-option value="PE">Pernambuco</mat-option>
              <mat-option value="PI">Piauí</mat-option>
              <mat-option value="RJ">Rio de Janeiro</mat-option>
              <mat-option value="RN">Rio Grande do Norte</mat-option>
              <mat-option value="RS">Rio Grande do Sul</mat-option>
              <mat-option value="RO">Rondônia</mat-option>
              <mat-option value="RR">Roraima</mat-option>
              <mat-option value="SC">Santa Catarina</mat-option>
              <mat-option value="SP">São Paulo</mat-option>
              <mat-option value="SE">Sergipe</mat-option>
              <mat-option value="TO">Tocantins</mat-option>
            </mat-select>
            <input *ngIf="exterior" type="text" matInput formControlName="estado" autocomplete="address-level1" aria-describedby="estado-error">
            <mat-error id="estado-error" *ngIf="fieldInvalid('estado')">{{ errorMessage('estado') }}</mat-error>
          </mat-form-field>

          <mat-form-field *ngIf="exterior" appearance="fill" class="col-5 country-field col-xs-12">
            <mat-label>País</mat-label>
            <mat-select formControlName="pais" aria-describedby="pais-error">
              <mat-option *ngFor="let pais of paises" [value]="pais.nome">{{ pais.nome }}</mat-option>
            </mat-select>
            <mat-error id="pais-error" *ngIf="fieldInvalid('pais')">{{ errorMessage('pais') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-5 phone-field col-xs-12">
            <mat-label>Celular</mat-label>
            <input *ngIf="!exterior" type="text" matInput formControlName="celular" mask="(00) 00000-0000" autocomplete="tel" inputmode="tel" aria-describedby="celular-error">
            <input *ngIf="exterior" type="text" matInput formControlName="celular" autocomplete="tel" inputmode="tel" aria-describedby="celular-error">
            <mat-error id="celular-error" *ngIf="fieldInvalid('celular')">{{ errorMessage('celular') }}</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="col-7 email-field col-xs-12">
            <mat-label>E-mail</mat-label>
            <input type="email" matInput formControlName="email" autocomplete="email" aria-describedby="email-error">
            <mat-error id="email-error" *ngIf="fieldInvalid('email')">{{ errorMessage('email') }}</mat-error>
          </mat-form-field>
        </div>
      </section>

      <section *ngIf="showCardFields" class="recurrence-section">
<!--        <mat-slide-toggle color="primary" formControlName="cadastrarRecorrencia">-->
<!--          <span class="desktop-title">Usar este cartão para pagamentos automáticos das próximas cobranças</span>-->
<!--          <span class="mobile-title">Usar este cartão nos próximos pagamentos</span>-->
<!--        </mat-slide-toggle>-->
<!--        <p>Você poderá gerenciar ou remover este cartão a qualquer momento nas configurações da conta.</p>-->

        <div class="recurrence-terms" *ngIf="form.get('cadastrarRecorrencia')?.value">
          <h3>Condições para o pagamento automático</h3>
          <ul>
            <li>Ao guardar o cartão de crédito, você concorda expressamente que serão debitados, na data de vencimento de cada contrato ativo, os valores das próximas cobranças.</li>
            <li>Para cancelar o pagamento automático, entre em contato com o nosso time financeiro.</li>
            <li>Se já existir um cartão de crédito cadastrado conosco, ele será substituído pelo informado acima.</li>
          </ul>
        </div>
      </section>

      <p class="submit-error" role="alert" aria-live="assertive" *ngIf="submitError">{{ submitError }}</p>
    </form>
  </div>

  <footer class="modal-footer">
    <div class="payment-total">
      <span class="desktop-total-label">Valor a pagar</span>
      <span class="mobile-total-label">Total</span>
      <strong>{{ paymentValueLabel }}</strong>
      <small>Cobrança única</small>
    </div>

    <div class="footer-actions">
      <button mat-button mat-dialog-close type="button" class="cancel-button">Cancelar</button>
      <button mat-raised-button color="primary" type="button" class="pay-button" [disabled]="!canSubmit" (click)="pagar()" [attr.aria-label]="canSubmit ? 'Confirmar pagamento com cartão' : 'Preencha os campos obrigatórios para pagar'">
        <mat-progress-spinner *ngIf="isSubmitting" mode="indeterminate" diameter="18"></mat-progress-spinner>
        <mat-icon *ngIf="!isSubmitting" aria-hidden="true">lock</mat-icon>
        <span class="desktop-title">{{ isSubmitting ? 'Processando...' : 'Pagar ' + paymentValueLabel }}</span>
        <span class="mobile-title">{{ isSubmitting ? 'Processando...' : 'Pagar' }}</span>
      </button>
    </div>
  </footer>
</section>
